import { ByPassInformation } from '@precheckin/models/bypass-information.model';
import { EVisitRecordType } from '@precheckin/models/visit/visit-record-type.enum';

export class VisitRecordPost {
  visitId: string;
  recordType: EVisitRecordType;
  recordDate: Date;
  identityPolicyConsentDate: Date;
  covidAcknowledgementDate: Date;
  bypasses: ByPassInformation[];

  constructor(data?: {
    visitId: string;
    covidAcknowledgementDate?: Date;
    recordType?: EVisitRecordType;
    recordDate?: Date;
    identityPolicyConsentDate?: Date;
    bypasses?: ByPassInformation[];
  }) {
    this.recordDate = new Date();
    if (data) {
      Object.assign(this, data);
    }
  }
}
